<template>
  <div class="list">
    <header><img src="@/assets/images/icons/member/taitou.png"></header>
    <div class="subtitle">充值后随即生效，查询更加便捷省心</div>
    <Row class-name="recharge-package" :gutter="50">
      <Col :span="recommendSize" v-for="item in recommendDataSet" :key="item.id">
        <div :class="['packace-content', $options.filters.getVipIcon(item.type, item.vip)]">
          <div :class="['top_area', item.tag]">
            <div :class="['arrow', item.tag]" v-if="item.tag"></div>
            <div class="name">{{item.name}}</div>
            <ul>
              <li>可获得<span>{{item.integral}}</span>查询积点</li>
              <li :style="{visibility: item.giftIntegral && item.giftIntegral > 0 ? 'visible' : 'hidden'}">额外赠送<span>{{item.giftIntegral}}</span>积点</li>
            </ul>
          </div>
          <div class="title"><span>{{item.type | getVipType(item.vip)}}</span></div>
          <div class="value"><span class="unit">¥</span><span class="price">{{parseFloat(item.amount) | padZeroPlaces}}</span><span class="unit2">元套餐</span></div>
          <div class="expire" v-if="item.type == 1 && item.expiryTime">自开通之日起至 {{item.expiryTime | dataFormat('dateTime.short2')}}</div>
          <div class="expire" v-else>自开通之日起至 {{(new Date()).getTime() | getMCardAfterMonthsTimestamp(item.vip, item.vipExpire) | dataFormat('dateTime.short2')}}</div>
          <div class="charge-btn" @click.prevent="toPay(1, item.id)">立即充值</div>
        </div>
      </Col>
    </Row>
    <div class="all_package" v-if="dataSet && dataSet.result && dataSet.count > 0">
      <ul>
        <li :class="$options.filters.getVipIcon(item.type, item.vip)" v-for="item in dataSet.result" :key="item.id">
          <div class="info">
            <div class="title">
              <span class="typename">{{item.type | getVipType(item.vip)}}</span>
              <span class="value">{{parseFloat(item.amount)}}元{{item.integral}}积点</span>
              <span class="name">{{item.name}}</span>
            </div>
            <div class="otherinfo">
              <span class="gift" v-if="item.giftIntegral && item.giftIntegral > 0">额外赠送查询积点：{{item.giftIntegral}}</span>
              <span class="expire" v-if="item.type == 1 && item.expiryTime">自开通之日起至 {{item.expiryTime | dataFormat('dateTime.short2')}}</span>
              <span class="expire" v-else>自开通之日起至 {{(new Date()).getTime() | getMCardAfterMonthsTimestamp(item.vip, item.vipExpire) | dataFormat('dateTime.short2')}}</span>
            </div>
          </div>
          <div class="charge-btn" @click.prevent="toPay(2, item.id)">立即充值</div>
        </li>
      </ul>
      <Page :total="dataSet.count" :page-size="pageSize" size="small" @on-change="getList" v-if="dataSet.count > pageSize"></Page>
    </div>
    <div class="explain">
      <div class="header clearfix">
        <div class="title">【套餐说明】<a class="rules line2" @click.stop.prevent="isShowRule=true">收费细则</a></div>
        <div class="action">
          <router-link :to="{name: 'MyIntegral'}" class="cash" >我的兑换</router-link>
          <router-link :to="{name: 'RechargeHistory'}" class="history">历史充值记录</router-link>
        </div>
      </div>
      <ul>
        <li>
          <div class="content">
            <p class="title">O-TECH会员服务介绍</p>
            <div class="desc">O-TECH会员服务，是O-TECH致力于向广大用户提供的增值尊贵服务，在获取最新自由贸易协定税率、原产地规则、商品税则、中美加征税率、CIQ信息、国际国内贸易法律法规、新闻活动信息之外，还可享受更多的增值功能和特权，包含参加O-TECH培训活动、国际国内论坛、线下专家帮助等，更多增值服务正在不断丰富中…</div>
          </div>
        </li>
        <li>
          <div class="content">
            <p class="title">收费说明</p>
            <div class="desc">月度会员：价格以具体页面显示为准。使用有效期：开通起31天。</div>
            <div class="desc">季度会员：价格以具体页面显示为准。使用有效期：开通起93天。</div>
            <div class="desc">年度会员：价格以具体页面显示为准。使用有效期：开通起365天。</div>
            <div class="desc">税率查询：1积点/次，每日24:00点前重复查询相同信息将不重复扣减积点。</div>
            <div class="desc">税则查询：1积点/次，每日24:00点前重复查询相同信息将不重复扣减积点。</div>
            <div class="desc">中美加征速查：1积点/次，每日24:00点前重复查询相同信息将不重复扣减积点。</div>
            <div class="desc">13位商品编码查询：1积点/次，每日24:00点前重复查询相同信息将不重复扣减积点。</div>
            <div class="desc">原产地规则查询：50积点/次；每日24:00点前重复查询相同信息将不重复扣减积点。</div>
          </div>
        </li>
        <li>
          <div class="content">
            <p class="title">如何加入O-TECH会员</p>
            <div class="desc">O-TECH会员加入路径：通过www.otechsolution.com或者O-TECH公众号，点击首页【账户】进入【注册／登陆】。登录账号后点击开通/续费会员，选择需要购买的服务套餐完成支付即可享受对应的会员服务。</div>
          </div>
        </li>
        <li>
          <div class="content">
            <p class="title">支付方式说明</p>
            <div class="desc">O-TECH会员开通可使用的支付渠道：支付宝、微信、银联支付、快捷支付、银行网银支付。</div>
          </div>
        </li>
      </ul>
    </div>
    <Loader :loadType="1" v-show="isShowLoader" class="black" style="top:-55px;"></Loader>
    <PayModal :pkg.sync="pkg"></PayModal>
    <ChargesModal :isShowRule="isShowRule" :isAutoShow="false" @ruleModalState="isShowRule = $event"></ChargesModal>
  </div>
</template>

<script>
import Loader from '@/components/layout/Loader'
import PayModal from './payModal'
import ChargesModal from '../ChargesModal'

export default {
  name: 'RechargeListZH',
  components: { Loader, PayModal, ChargesModal },
  data () {
    return {
      isShowLoader: false,
      isShowRule: false,
      pageSize: 4,
      dataSet: {},
      recommendSize: 6,
      recommendDataSet: [],
      pkg: {}
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getList(0, res => {
        this.recommendDataSet = res.result
        this.recommendSize = 24 / (this.recommendDataSet.length || 1)
      })
    })
  },
  methods: {
    getList (page, callback) {
      if (this.isShowLoader) return
      this.$Loading.start()
      this._h.scrollTop()
      this.isShowLoader = true
      this.$api.account.member.recharge.list({ page: page ? page + 1 : 1, size: this.pageSize }, {
        success: (response) => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            if (callback) {
              callback(response.data.data)
            } else {
              response.data.data.count -= this.recommendDataSet.length
              this.dataSet = response.data.data
            }
          } else {
            this.$Message.warning({content: this.$t('common.codeError'), closable: true})
          }
          this.isShowLoader = false
          if (callback) this.getList(1)
        },
        error: errorMsg => {
          this.isShowLoader = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    },
    toPay (from, id) {
      if (from === 1) {
        this.pkg = this._.find(this.recommendDataSet, item => item.id === parseInt(id))
      } else {
        this.pkg = this._.find(this.dataSet.result, item => item.id === parseInt(id))
      }
    }
  }
}
</script>
<style scoped>
header{
  margin-bottom: 10px;
}
header img{
  width: 350px;
  margin: 42px auto 0;
}
.subtitle{
  color: #999;
  text-align: center;
  font-size: 12px;
}
.explain{
  margin-bottom: 45px;
}
.explain .header{
  color: #999;
  border-bottom: 1px solid #ECECEC;
  padding-bottom: 15px;
  margin-bottom: 20px;
}
.explain .header .title{
  font-size: 13px;
  float: left;
  position: relative;
}
.explain .header .action{
  float: right;
  margin-right: 10px;
}
.explain .header .action a{
  color: #999;
}
.explain .header a::after{
  background-color: #999;
}
.explain .header .action a.cash,
.explain .header .action a.history{
  background: url("~@/assets/images/icons/member/icon_wddh.png") 0 center no-repeat transparent;
  background-size: 12px auto;
  padding-left: 15px;
  z-index: 1;
  display: inline-block;
}
.explain .header .action a.cash{
  position: relative;
  left: -15px;
}
.explain .header .action a.history{
  background-image: url("~@/assets/images/icons/member/icon_lsjl.png");
}
.explain .header a.rules{
  background: url("~@/assets/images/icons/member/yiwen2.png") 0 center no-repeat transparent;
  background-size: 15px auto;
  font-size: 12px;
  padding-left: 20px;
  position: relative;
  left: 30px;
  cursor: pointer;
  z-index: 1;
  color: #1F8AFD;
  margin-right: 0;
  float: none;
}
.explain .header a.rules::after{
  background-color: #1F8AFD;
}
.explain li{
  position: relative;
  padding-right: 5px;
  margin-bottom: 20px;
  font-size: 13px;
}
.explain li:last-child{
  margin-bottom: 0;
}
.explain li .title{
  margin-bottom: 5px;
  padding-bottom: 2px;
  font-weight: bold;
  line-height: 20px;
  color: #333;
}
.explain li .title,
.explain li .desc{
  line-height: 22px;
}
.explain li .desc{
  color: #999;
}
.list >>> .recharge-package{
  margin: 45px 0;
}
.list >>> .recharge-package .ivu-col .packace-content{
  width: 230px;
  background: #fff;
  box-shadow: -5px -6px 13px 0 rgba(231,231,231,0.50), 5px 6px 13px 0 rgba(231,231,231,0.50);
  position: relative;
}
.list >>> .recharge-package .ivu-col .packace-content .top_area{
  background-image: linear-gradient(90deg, #299CFF 0%, #0CCFEC 99%);
  padding: 18px 15px;
  color: #fff;
}
.list >>> .recharge-package .ivu-col .packace-content .top_area.new{
  background-image: linear-gradient(90deg, #299CFF 0%, #0CCFEC 99%);
}
.list >>> .recharge-package .ivu-col .packace-content .top_area.hot{
  background-image: linear-gradient(90deg, #FF8E29 0%, #FCBD0F 99%);
}
.list >>> .recharge-package .ivu-col .packace-content .top_area ul{
  font-size: 11px;
  margin-left: 1px;
}
.list >>> .recharge-package .ivu-col .packace-content .top_area ul li{
  background: url("~@/assets/images/icons/member/duigou.png") 0 center no-repeat transparent;
  background-size: 11px auto;
  padding-left: 16px;
  margin-bottom: 5px;
}
.list >>> .recharge-package .ivu-col .packace-content .top_area ul li span{
  padding: 0 2px;
}
.list >>> .recharge-package .ivu-col .packace-content .title{
  margin: 10px 15px;
}
.list >>> .recharge-package .ivu-col .packace-content .title span{
  color: #999;
  background: url("~@/assets/images/icons/member/tc.png") no-repeat 0 center transparent;
  background-size: 13px auto;
  padding-left: 17px;
  font-size: 13px;
}
.list >>> .recharge-package .ivu-col .packace-content.yk .title span{
  background-image: url("~@/assets/images/icons/member/yk.png");
  color: #1ECD7A;
}
.list >>> .recharge-package .ivu-col .packace-content.jk .title span{
  background-image: url("~@/assets/images/icons/member/jk.png");
  color: #318FFF
}
.list >>> .recharge-package .ivu-col .packace-content.nk .title span{
  background-image: url("~@/assets/images/icons/member/nk.png");
  color: #FF8C45;
}
.list >>> .recharge-package .ivu-col .packace-content .value{
  margin-bottom: 5px;
  padding: 0 15px;
}
.list >>> .recharge-package .ivu-col .packace-content .unit{
  font-size: 12px;
  color: #FE628D;
  padding-right: 2px;
}
.list >>> .recharge-package .ivu-col .packace-content .price{
  font-size: 18px;
  color: #FE628D;
}
.list >>> .recharge-package .ivu-col .packace-content .unit2{
  font-size: 12px;
  color: #B3B3B3;
  padding-left: 5px;
}
.list >>> .recharge-package .ivu-col .packace-content .name{
  font-size: 15px;
  margin-bottom: 8px;
}
.list >>> .recharge-package .ivu-col .packace-content .gift{
  color: #999;
  font-size: 12px;
}
.list >>> .recharge-package .ivu-col .packace-content .expire{
  margin-left: 15px;
  padding: 0 15px 0 16px;
  color: #B3B3B3;
  font-size: 11px;
  margin-bottom: 25px;
  background: url("~@/assets/images/icons/member/riqi.png") no-repeat 0 center transparent;
  background-size: 12px auto;
}
.list >>> .recharge-package .ivu-col .packace-content .charge-btn{
  width: 100%;
  text-align: center;
  background-image: linear-gradient(90deg, #FE628D 0%, #FD9596 100%);
  color: #fff;
  height: 30px;
  line-height: 30px;
  margin: 0 auto;
  cursor: pointer;
}
.list >>> .recharge-package .ivu-col .packace-content .arrow{
  width: 50px;
  height: 18px;
  position: absolute;
  top: 0;
  right: 0;
  background: url("~@/assets/images/icons/member/hot.png") no-repeat 0 center transparent;
  background-size: 50px auto;
}
.list >>> .recharge-package .ivu-col .packace-content .arrow.new{
  background-image: url("~@/assets/images/icons/member/new.png");
}
.all_package{
  margin-bottom: 25px;
}
.all_package li{
  padding: 15px 0;
  border-bottom: 1px solid #ECECEC;
  position: relative;
  padding-right: 160px;
}
.all_package li:last-child{
  border-bottom: 0 none;
}
.all_package li .info .title{
  margin-bottom: 8px;
}
.all_package li .info .title .typename{
  background: url("~@/assets/images/icons/member/tc.png") no-repeat 0 center transparent;
  background-size: 13px auto;
  padding-left: 18px;
  color: #999;
  font-size: 12px;
  position: relative;
  top: -2px;
}
.all_package li.yk .info .title .typename{
  background-image: url("~@/assets/images/icons/member/yk.png");
  color: #1ECD7A;
}
.all_package li.jk .info .title .typename{
  background-image: url("~@/assets/images/icons/member/jk.png");
  color: #318FFF
}
.all_package li.nk .info .title .typename{
  background-image: url("~@/assets/images/icons/member/nk.png");
  color: #FF8C45;
}
.all_package li .info .title .value{
  font-size: 16px;
  color: #333;
  padding: 0 20px;
}
.all_package li .info .title .name{
  font-size: 14px;
  color: #999;
}
.all_package li .info .otherinfo{
  font-size: 12px;
  color: #B3B3B3;
}
.all_package li .info .otherinfo .gift{
  padding-right: 15px;
}
.all_package .charge-btn{
  width: 100px;
  text-align: center;
  border: 1px solid #1F8AFD;
  color: #1F8AFD;
  border-radius: 6px;
  height: 30px;
  line-height: 28px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
.all_package >>> .ivu-page{
  margin: 20px 0;
  text-align: center;
}
.all_package >>> .ivu-page.mini .ivu-page-item{
  border: 1px solid #EDEDED;
  margin: 0 3px;
}
.all_package >>> .ivu-page.mini .ivu-page-item a{
  color: #999;
  font-size: 15px;
}
.all_package >>> .ivu-page-item-active{
  background-color: #1F8AFD;
}
.all_package >>> .ivu-page.mini .ivu-page-item.ivu-page-item-active a{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/member/zh-CN/recharge/List.vue